import type { FieldErrors, FieldValues, Resolver } from 'react-hook-form';
import type { ZodType } from 'zod';

/**
 * `react-hook-form` uchun Zod ko'prigi. `@hookform/resolvers` paketi o'rniga
 * o'z funksiyamiz turadi: kerakli xatti-harakat o'n qatorga sig'adi va
 * `apps/web` ning bog'liqliklar ro'yxati yupqa qoladi.
 *
 * Har bir maydon uchun **birinchi** xato olinadi — foydalanuvchiga bir vaqtda
 * bitta aniq ko'rsatma beriladi.
 */
export const zodResolver =
  <T extends FieldValues>(schema: ZodType<T>): Resolver<T> =>
  (values) => {
    const parsed = schema.safeParse(values);
    if (parsed.success) return Promise.resolve({ values: parsed.data, errors: {} });

    const errors: Record<string, { type: string; message: string }> = {};
    for (const issue of parsed.error.issues) {
      const path = issue.path.join('.');
      if (path.length > 0 && errors[path] === undefined) {
        errors[path] = { type: issue.code, message: issue.message };
      }
    }

    return Promise.resolve({ values: {}, errors: errors as unknown as FieldErrors<T> });
  };
